"use strict";
exports.__esModule = true;
exports.ClassPrefixContext = exports.ClassPrefixProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var defaultState = '';
var ClassPrefixContext = react_1["default"].createContext(defaultState);
exports.ClassPrefixContext = ClassPrefixContext;
var ClassPrefixProvider = function (_a) {
    var children = _a.children, classPrefix = _a.classPrefix;
    var prefix = classPrefix ? classPrefix + "-" : '';
    return (react_1["default"].createElement(ClassPrefixContext.Provider, { value: prefix }, children));
};
exports.ClassPrefixProvider = ClassPrefixProvider;
//# sourceMappingURL=ClassPrefixContext.js.map